// Component to switch between the current day of dispatch schedule
import clsx from 'clsx';

import { useSchedulerContext } from '@/context/SchedulerContext';

import { addDays, daysLabels, getIsSameDay } from '@isd/lib/helpers/dates';

export default function SchedulerDaySwitch() {
  const { schedulerCurrentDate, schedulerStartDate, setSchedulerCurrentDate } =
    useSchedulerContext();
  return (
    <div className="scheduler-day-switch tabs xl:tabs-border mb-[-2px] h-full grid-cols-7 justify-between md:flex md:h-auto xl:justify-start">
      {daysLabels.map((dayLabel, idx) => {
        const date = addDays(schedulerStartDate, idx);
        const isActive = getIsSameDay(schedulerCurrentDate, date);
        const dateTip = date.toDateString();
        const isToday = dateTip === new Date().toDateString();
        return (
          <div
            key={dayLabel}
            className={clsx(
              'tab h-full min-h-12 grow px-0 text-lg lg:px-10 xl:min-w-32',
              isActive
                ? 'tab-active bg-base-150 rounded-none!' +
                    ' before:left-0! before:border-t-0! lg:before:h-[2px]! lg:before:w-full!'
                : 'border-base-200! text-primary-dark! font-bold'
            )}
            onClick={() => setSchedulerCurrentDate(date)}
          >
            <div
              className={clsx(
                'tooltip lg:tooltip-top w-full',
                idx === 0
                  ? 'tooltip-right'
                  : idx === daysLabels.length - 1
                    ? 'tooltip-left'
                    : 'tooltip-top'
              )}
              data-tip={`${dateTip}${isToday ? ' (Today)' : ''}`}
            >
              {dayLabel}
              {isToday && (
                <div className="today-indicator absolute top-3 w-full text-xl font-bold">
                  {'.'}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
